import { css } from '@emotion/react';

export const base = css`
    padding: 42px 8% 20px 8%;
    margin: 0;
    display: flex;
    justify-content: space-between;
    font-family: 'Roboto', sans-serif;

    @media (max-width: 768px) {
        flex-direction: column;
        padding: 32px 8% 24px 8%;
    }
`;

export const footerItem1 = css`
    width: 30%;
    margin: 0;
    padding: 0;

    @media (max-width: 768px) {
        width: 100%;
        margin-bottom: 0;
    }
`;

export const footerItem2 = css`
    margin: 0;
    padding: 0;
`;

export const footerItem3 = css`
    margin: 0;
    padding: 0;
`;

export const footerItem4 = css`
    margin-top: 16px;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
`;

export const companyLogo = css`
    text-align: left;
    margin: 0;
    padding: 0;

    h3 {
        font-family: 'Helvetica', sans-serif;
        font-size: 28px;
        color: #42454d;
        margin-top: 0;
        margin-bottom: 16px;
        margin-left: 0;
        margin-right: 0;
        padding: 0;
        font-weight: normal;
    }

    @media (max-width: 768px) {
        font-family: 'Helvetica', sans-serif;
        font-size: 18px;
        margin-bottom: 24px;
    }
`;

export const address = css`
    text-align: left;
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;

    p {
        font-family: 'Roboto', sans-serif;
        font-size: 13px;
        font-weight: normal;
        margin: 0;
        padding: 0;
    }

    @media (max-width: 768px) {
        width: 100%;

        p {
            font-size: 12px;
        }
    }

    @media only screen and (min-device-width: 700px) and (max-device-width: 1023px) {
        width: 50%;
    }
`;

export const auditor = css`
    margin-top: 30px;
    text-align: left;
    font-family: 'Roboto', sans-serif;

    h4 {
        margin: 0;
        padding: 0;
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        font-weight: normal;
    }

    img {
        width: 25%;
        margin-right: 10px;
    }

    @media (max-width: 768px) {
        margin-top: 24px;

        h4 {
            margin: 0;
        }

        img {
            width: 20%;
            margin-right: 12px;
        }
    }

    @media only screen and (min-device-width: 700px) and (max-device-width: 1023px) {
        img {
            width: 12%;
        }
    }
`;

export const links = css`
    margin-top: 16px;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    text-align: left;
    font-family: 'Roboto', sans-serif;

    a {
        color: #42454d;
        margin: 0;
        padding: 0;
        font-family: 'Roboto', sans-serif;
    }

    p {
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        font-weight: normal;
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 12px;
        padding: 0;
        cursor: pointer;
    }

    @media (max-width: 768px) {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;

        p {
            font-size: 12px;
            margin-bottom: 10px;
            font-weight: 500;
        }
    }

    @media only screen and (min-device-width: 700px) and (max-device-width: 1023px) {
        justify-content: flex-start;
    }
`;

export const linksWrapper = css`
    @media (max-width: 699px) {
        &:nth-of-type(2) {
            padding-right: 24px;
        }
    }

    @media only screen and (min-device-width: 700px) and (max-device-width: 1023px) {
        &:nth-of-type(2) {
            padding-left: 24px;
            padding-right: 0;
        }
    }
`;

export const contactUs = css`
    text-align: left;
    margin: 0;
    padding: 0;
    font-family: 'Roboto', sans-serif;

    h4 {
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 10px;
        padding: 0;
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        font-weight: normal;
    }

    p {
        font-family: 'Roboto', sans-serif;
        font-size: 13px;
        font-weight: normal;
        margin-top: 0;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 20px;
        padding: 0;
    }

    @media (max-width: 768px) {
        margin-top: 16px;

        p {
            font-size: 12px;
        }
    }
`;

export const withLogo = css`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 12px;
    font-family: 'Roboto', sans-serif;

    a {
        color: #42454d;
        display: inline;
        font-family: 'Roboto', sans-serif;
        text-decoration: none;
    }

    img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
    }

    p {
        padding-left: 10px;
        margin: 0;
        display: inline;
        font-family: 'Roboto', sans-serif;
        font-size: 13px;
        font-weight: normal;
    }

    @media (max-width: 768px) {
        margin-bottom: 12px;

        p {
            margin: 0;
            margin-left: 10px;
            display: inline;
            font-size: 12px;
        }

        a {
            color: #42454d;
        }
    }
`;

export const mediaSocial = css`
    margin-top: 20px;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    text-align: left;
    font-family: 'Roboto', sans-serif;

    h4 {
        margin: 0;
        padding: 0;
        font-family: 'Roboto', sans-serif;
        font-size: 14px;
        font-weight: normal;
    }

    a {
        margin: 0;
        padding: 0;
    }

    img {
        width: 10%;
        margin-top: 0;
        margin-bottom: 0;
        margin-left: 0;
        margin-right: 10px;
        padding: 0;
        cursor: pointer;
    }

    @media (max-width: 768px) {
        margin-top: 16px;
        margin-bottom: 72px;

        h4 {
            margin: 0;
            margin-bottom: 8px;
        }

        img {
            width: 8%;
            margin-right: 14px;
        }
    }

    @media only screen and (min-device-width: 700px) and (max-device-width: 1023px) {
        img {
            width: 4%;
        }
    }
`;
